export default "__VITE_ASSET__BsdGc2mp__"